import { PropsWithChildren } from 'react'
import { observer } from 'mobx-react-lite'
import { useLayout } from 'stores/LayoutStore'
import { Portal } from 'components/Portal/Portal'

export const PostPreview = observer(({ children }: PropsWithChildren) => {
  const layout = useLayout()

  if (!layout.postPreview) return null

  return <Portal container={layout.postPreview}>{children}</Portal>
})
